var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_13305",
    "data-name": "Group 13305",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2874",
    "data-name": "Rectangle 2874",
    width: 20,
    height: 20,
    fill: "#6249ef"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13304",
    "data-name": "Group 13304",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12943",
    "data-name": "Path 12943",
    d: "M3.579,19.151a6.6,6.6,0,0,1-2.51-9.435L6.5,1.015A.759.759,0,0,1,7.49.769a.647.647,0,0,1,.267.919h0l-5.428,8.7a5.278,5.278,0,0,0,2.008,7.548A6.2,6.2,0,0,0,12.4,15.772l5.555-8.9a3.518,3.518,0,0,0-1.339-5.032A4.136,4.136,0,0,0,11.241,3.28L6.192,11.373A1.724,1.724,0,0,0,6.9,13.825a2.027,2.027,0,0,0,2.649-.656h0l4.923-7.891a.76.76,0,0,1,.993-.247.647.647,0,0,1,.267.919h0l-4.923,7.892A3.62,3.62,0,0,1,6.1,15.1a3.078,3.078,0,0,1-1.171-4.4L9.982,2.607A5.687,5.687,0,0,1,17.376.623a4.837,4.837,0,0,1,1.841,6.919l-5.554,8.9A7.755,7.755,0,0,1,3.579,19.151",
    fill: "#6249ef"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinIcon);
export default __webpack_public_path__ + "static/media/pinIcon.42f0878e020655bba8ef661cb2b4ce4d.svg";
export { ForwardRef as ReactComponent };